import { profileInformation } from '../../user';
import { getBackEndVars } from '../../payments/paypal/getVariables';
import { getDiscountFlow } from '../../payments/discount-flow';
import store from '../../store';
import { getCustomerUuid } from '../../common-helpers/getCustomerUuid';

const getAdditionalTrackingData = () => {
  return {
    profile: profileInformation(),
    products: [
      {
        id: getBackEndVars().purchasableUUID,
        category: getBackEndVars().domainType,
        name: getBackEndVars().purchasableIdentifier,
        quantity: 1,
        discountFlow: getDiscountFlow(),
      },
    ],
  };
};

export const buildEvent = () => {
  return tracking.event({
    eventType: 'AddToCart',
    systemType: backEndVars.systemType,
    uri: window.location.pathname,
    domain: window.location.hostname,
    email: store.getAnswers()['saved-email'] || null,
    phone: store.get('__ph') || null,
    customerUuid: getCustomerUuid(),
    additionalData: getAdditionalTrackingData(),
    utmParams: store.getMarketingInfo('lastUtmParams'),
  });
};

export default {
  buildEvent,
};
